import React from 'react';
import '../../ImageSwich/ImageSwitch.css';
import './AllseisShow.css';
// import AllseisButton from './AllseisButton';
// import { ArrowType } from "../../tools/ArrowType";

export default function AllseisShow(props: {
    children?: JSX.Element | Array<JSX.Element>
}) {
    // const [pos, camera, film, isLeft, isRight, handleLeft, handleRight] = useImageSwitch(props.children)
    return (
        // <div ref={camera} className="allseis-show image-switch-camera">
        //     <AllseisButton arrowType={ArrowType.LEFT} onClick={handleLeft} disabled={isLeft} />
        //     <AllseisButton arrowType={ArrowType.RIGHT} onClick={handleRight} disabled={isRight} />
        //     <div ref={film} className="image-switch-film allseis-width" style={{left: pos + "px"}}>
        //         {props.children}
        //     </div>
        // </div>
        <>
            {props.children}
        </>
    )

}